import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, bancos) {
        state.list = bancos;
        state.selectList = bancos.map(banco => banco.nombre.trim());
    },
};

const actions = {
    getList: ({ commit }, paisId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let query = '';
            if (paisId) {
                if (paisId != 0) {
                    query= '?paisId=' + paisId;
                }
            }

            apiAxios.get('provincias/list' + query)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    localidadesProvinciaList (state) {
        return state.localidadesProvinciaList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}